module.exports = __webpack_public_path__ + "static/img/banner-en.113c62bb.png";